export const HUBSPOT_VIDEO_2_PROVIDER = 'HUBSPOT_VIDEO_2';

export const MUX_THUMBNAIL_DOMAIN = 'image.mux.com';
export const DEFAULT_MUX_POSTER_WIDTH = 1200;

export enum REQUEST_STATUS_TYPES {
  UNINITIALIZED = 'UNINITIALIZED',
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  NOT_FOUND = 'NOT_FOUND',
}

export type RequestStatus = keyof typeof REQUEST_STATUS_TYPES;
